import { z } from 'zod';

export const getReportingTemplateByIdSchema = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  code: z.string().optional(),
  name: z.string().optional(),
  functionality: z.number(),
  documentTypeId: z.string().uuid().optional(),
  documentType: z
    .object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
      description: z.string(),
    })
    .optional(),
  isManager: z.boolean().optional(),
  isClient: z.boolean().optional(),
  template: z.string().optional(),
  datasourceScript: z.string().optional(),
  parametersJson: z.string().optional(),
});

export type GetReportingTemplateById = z.infer<typeof getReportingTemplateByIdSchema>;
